import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, getIn, FieldArray } from 'formik';
import { DataTable } from 'components/data-table';
import TextField from '../text-field/TextField';

const DataTableField = connect(
  ({
    name,
    label,
    placeholder,
    formik: { values, errors },
    tools = [],
    columns = [],
    actions = [],
    initialAddValues,
    disableDeletingLastOne = false,
    disableAdd = false,
    cssClass,
    addNewLabel,
    ...props
  }: any) => {
    const { t } = useTranslation();
    const value = getIn(values, name);
    const error = getIn(errors, name);

    const tableColumns = useMemo(
      () =>
        columns.map((column) => ({
          ...column,
          render: ({ value, rowIndex, placeholder }) => {
            const name1 = `${name}[${rowIndex}].${column.name}`;
            if (column.render) return column.render({ value, rowIndex, name: name1, placeholder });

            return (
              <TextField
                name={name1}
                placeholder={t(`placeholder.enter${column.label}`)}
                fullWidth
              />
            );
          },
        })),
      [columns, name, t]
    );

    const shouldShowDeleteIcon = Boolean(value) && (!disableDeletingLastOne || value.length !== 1);

    return (
      <FieldArray
        name={name}
        render={({ push, remove }) => {
          const dataTools = [
            ...tools,
            {
              label: 'Add',
              text: addNewLabel || `${t('button.addNew')}`,
              icon: 'add',
              onClick: () => {
                push(initialAddValues);
              },
            },
          ];

          const dataActions = shouldShowDeleteIcon
            ? [
                ...actions,
                {
                  label: 'Delete',
                  icon: 'delete',
                  onClick: (row, index) => {
                    remove(index);
                  },
                },
              ]
            : actions;

          return (
            <DataTable
              placeholder={placeholder}
              isFormTable={true}
              title={label}
              data={value}
              tools={dataTools}
              columns={tableColumns}
              actions={dataActions}
              error={error}
              cssClass={cssClass}
              {...props}
            />
          );
        }}
      />
    );
  }
);

export default DataTableField;
